
import React, { Fragment, useEffect, useState } from 'react';

import { decompressGUID } from 'modules/5_view_helpers/guidConverter';
import { getProductionStrumisContractDocumentGetByGUID } from 'modules/production/strumis/contract/documents/actions';
import { connect } from 'react-redux';
import { DrawingRevisionsTabs } from 'modules/project/drawings/web/modal';
import _ from 'lodash';

function mapStateToProps(state) {
    return {
        production_strumis_contract_documents: state.production_strumis_contract_documents
    }
}

const DrawingsTab = (props) => {
    const { object, production_strumis_contract_documents } = props
    const [GUID, setGUID] = useState(object?.guid || null)
    useEffect(() => {
        if (object?.guid) {
            setGUID(object.guid)
            return
        }
        if (object?.GlobalId) {
            setGUID(decompressGUID(object.GlobalId))
        }
    }, [object])

    useEffect(() => {
        if (GUID) {
            props.getProductionStrumisContractDocumentGetByGUID(GUID)
        }
    }, [GUID])


    return (
        <Fragment>
            {_.isEmpty(production_strumis_contract_documents) && (<div>Loading...</div>)}
            <div style={{ height: "80vh" }} >
                <DrawingRevisionsTabs
                    drawing={production_strumis_contract_documents}
                />
            </div>
        </Fragment >
    )
}

export default connect(mapStateToProps, { getProductionStrumisContractDocumentGetByGUID })(DrawingsTab);

